import confetti from "canvas-confetti";

/**
 * Gold/navy celebratory burst for chapter completion.
 * Tuned short so it doesn't get in the way.
 */
export function chapterConfetti() {
    const defaults = {
        spread: 70,
        ticks: 180,
        gravity: 0.9,
        decay: 0.92,
        startVelocity: 38,
        colors: ["#D4A140", "#E8C07A", "#F4E3C1", "#0E1E3A"],
        disableForReducedMotion: true,
    };
    // Two quick bursts from the bottom corners
    confetti({ ...defaults, particleCount: 70, origin: { x: 0.2, y: 0.95 } });
    confetti({ ...defaults, particleCount: 70, origin: { x: 0.8, y: 0.95 } });
}

/**
 * Bigger, slower celebration for a fresh program-completion certificate.
 * Three staggered bursts across the top of the viewport.
 */
export function certificateConfetti() {
    const base = {
        spread: 110,
        ticks: 260,
        gravity: 0.7,
        decay: 0.94,
        startVelocity: 45,
        colors: ["#D4A140", "#E8C07A", "#F4E3C1", "#0E1E3A", "#FFFFFF"],
        disableForReducedMotion: true,
    };
    confetti({ ...base, particleCount: 140, origin: { x: 0.5, y: 0.2 } });
    setTimeout(
        () => confetti({ ...base, particleCount: 90, origin: { x: 0.15, y: 0.3 } }),
        250,
    );
    setTimeout(
        () => confetti({ ...base, particleCount: 90, origin: { x: 0.85, y: 0.3 } }),
        500,
    );
}
